export default __webpack_public_path__ + "static/media/โปรบอลเสต็ป.38507ff2.png";